<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Site Details</h3>
    </div>
    <div class="panel-flat-body position-relative" [formGroup]="form()">
        <div
            class="referral-field-grid"
            style="margin-bottom: 16px"
            [style.align-items]="editMode() ? 'center' : 'flex-start'"
        >
            <label class="referral-field-label" for="siteName">Property/Site Name</label>
            <referral-input-with-revert
                formControlName="siteName"
                [systemValue]="systemReferral()?.siteName"
                [originalValue]="originalReferral()?.siteName"
                [maxlength]="100"
            />
            <label
                class="referral-field-label"
                style="align-self: start"
                [style.margin-top.px]="editMode() ? 3 : 0"
                for="siteAddress"
            >
                Property Address
            </label>
            <div>
                <referral-input-with-revert
                    formControlName="siteAddress1"
                    [systemValue]="systemReferral()?.siteAddress1"
                    [originalValue]="originalReferral()?.siteAddress1"
                    placeholder="Address 1"
                    [maxlength]="50"
                />
                <div>
                    <referral-input-with-revert
                        formControlName="siteAddress2"
                        [systemValue]="systemReferral()?.siteAddress2"
                        [originalValue]="originalReferral()?.siteAddress2"
                        placeholder="Address 2"
                        [maxlength]="50"
                    />
                </div>
                <div style="display: flex; gap: 4px">
                    <div style="display: flex">
                        <referral-input-with-revert
                            formControlName="siteCity"
                            [systemValue]="systemReferral()?.siteCity"
                            [originalValue]="originalReferral()?.siteCity"
                            placeholder="City"
                            [maxlength]="30"
                        />
                        @if (!editMode() && (referral()?.siteCity || referral()?.siteState || referral()?.siteZip)) {
                            <span>,</span>
                        }
                    </div>
                    <referral-input-with-revert
                        formControlName="siteState"
                        [systemValue]="systemReferral()?.siteState"
                        [originalValue]="originalReferral()?.siteState"
                        placeholder="State"
                        [maxlength]="5"
                    />
                </div>
                <referral-input-with-revert
                    formControlName="siteZip"
                    [systemValue]="systemReferral()?.siteZip"
                    [originalValue]="originalReferral()?.siteZip"
                    placeholder="ZIP"
                    [maxlength]="10"
                />
            </div>
            <label class="referral-field-label" for="siteParcelAcctNums">Parcel ID(s)</label>
            <referral-input-with-revert
                formControlName="siteParcelAcctNums"
                [systemValue]="systemReferral()?.siteParcelAcctNums"
                [originalValue]="originalReferral()?.siteParcelAcctNums"
            />
            <label class="referral-field-label" for="siteClassPrimary">Property Type</label>
            <referral-input-with-revert
                formControlName="siteClassPrimary"
                [systemValue]="systemReferral()?.siteClassPrimary"
                [originalValue]="originalReferral()?.siteClassPrimary"
                [selectOptions]="siteClassPrimaryOptions"
            />
            <label class="referral-field-label" for="siteClassSecondary">Property/Account Detail</label>
            <referral-input-with-revert
                formControlName="siteClassSecondary"
                [systemValue]="systemReferral()?.siteClassSecondary"
                [originalValue]="originalReferral()?.siteClassSecondary"
                [selectOptions]="siteClassSecondaryOptions()"
            />
            <span class="referral-field-label">PropertyPoint Property ID</span>
            <span>{{ referral()?.primarySiteId }}</span>
        </div>
        <div class="card panel-flat-color secondary-panel small-panel" style="margin-bottom: 0">
            <div class="panel-flat-header small-header">
                <h3>Appeal List</h3>
                <div class="float-end header-button-container" style="margin-top: -3px">
                    @if (editMode()) {
                        <button type="button" class="ace-btn btn-text has-icon btn-primary" (click)="syncAllAppeals()">
                            <i class="fa fa-rotate"></i>
                        </button>
                    }
                </div>
            </div>
            <div class="card-body">
                <ws-ag-grid-angular
                    rowSelection="multiple"
                    (selectionChanged)="onSelectionChanged($event)"
                    [gridId]="gridId"
                    [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                    (bulkDelete)="bulkDelete()"
                    [showConfigureLayout]="false"
                    [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    (firstDataRendered)="onFirstDataRendered($event)"
                >
                </ws-ag-grid-angular>
                @if (editMode()) {
                    <div style="margin-top: 8px; display: flex; justify-content: flex-end">
                        <button
                            class="ace-btn btn-primary btn-sm"
                            (click)="selectPrimary()"
                            [hidden]="!canSelectPrimary()"
                        >
                            Select Primary
                        </button>
                        <button class="ace-btn btn-primary btn-sm" (click)="launchAppealModal()"> Add Appeals </button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
